import { clsx } from 'clsx'

import { BannerPlaceholder } from '@tribeplatform/react-components/common/components'
import type { StaticField } from '@tribeplatform/react-components/Views'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'

import type { QuickLinksSource } from '../types.js'

interface Props {
  source: QuickLinksSource
  field: StaticField
  highlighted: boolean
  mediaUrl: string
}
export const ListImage = ({ source, field, highlighted, mediaUrl }: Props) => {
  return (
    <div className="shrink-0">
      {!mediaUrl ? (
        <BannerPlaceholder
          className={clsx(
            'h-16 w-16 flex justify-center items-center rounded-base',
            'overflow-hidden',
            highlighted && 'ring-2 ring-offset-surface ring-focused',
          )}
          name={source?.id}
        />
      ) : (
        <Avatar
          size={field.settings?.avatarSize ?? 'lg'}
          src={mediaUrl}
          name={source.title}
          rounded="md"
          className={clsx(
            highlighted &&
              'ring-2 ring-offset-surface ring-focused rounded-base',
          )}
        />
      )}
    </div>
  )
}
